import { render, staticRenderFns } from "./Unapproved.vue?vue&type=template&id=371523a0&"
import script from "./Unapproved.vue?vue&type=script&lang=js&"
export * from "./Unapproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports